import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/store/auth.store'
import { PortalLayout } from '@/features/employee-portal/components/PortalLayout'

export const Route = createFileRoute('/employee')({
  beforeLoad: () => {
    const { accessToken } = useAuthStore.getState()
    if (!accessToken) {
      throw redirect({ to: '/login' })
    }
  },
  component: PortalLayout,
})
